export default __webpack_public_path__ + "media/Gym_perspective_matte.6c20b143.png";